import api from "../api/api";


const getEmergencyContactList = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/emergency-contact-list",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getCmsPages = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/cms-pages",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getSuggestionList = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/cms-suggestion",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const cmsServices = {
    getEmergencyContactList,
    getSuggestionList,
    getCmsPages
}

export default cmsServices